/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    PDFViewer,
    Image,
    Link,
} from "@react-pdf/renderer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import axios from "axios";
import "./createCatalog.css";
import PdfHeader from "./pdfHeader";
import PdfFooter from "./pdfFooter";
import TopBanner from "./images/STORELOOKBOOKCOVER.jpg";
// import TopBanner from "./images/STORE_PDFF_1.jpg";
import TopSecBanner from "./images/STORE_PDFF_2.jpg";
import FooterBanner from "./images/STORE_PDFF_6.jpg";
import Indian_Rupee_symbol from "./Indian_Rupee_symbol.svg";

const styles = StyleSheet.create({
    page: {
        // position: "relative",
        // flexDirection: "col",
        // backgroundColor: "#fff",
    },
    headerBannerSection: {
        width: "100%",
        height: "100%",
    },
    headerBannerSectionImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    // productSection: {
    //     width: "100%",
    //     height: "100%",
    // },
    // productImageSection: {
    //     width: "100%",
    //     height: "100%",
    // },
    // productImage: {
    //     width: "100%",
    //     height: "100%",
    //     objectFit: "cover",
    // },
    // productInfoSection: {
    //     position: "relative",
    //     top: "40%",
    //     left: "10%",
    // },
    productSection: {
        position: 'relative', // Ensure the section can contain absolute children
        width: '100%',
        height: '100%',
    },
    productImageSection: {
        width: '100%', // Image takes full width of the page
        height: '100%', // Image takes full height of the page
    },
    productImage: {
        width: '100%', // Ensure the image fills the section
        height: '100%', // Ensure the image fills the section
        objectFit: 'cover', // Cover the area while maintaining aspect ratio (crops if needed)
    },
    productInfoSection: {
        position: 'absolute', // Overlay the text on top of the image
        left: 20, // Position 20 units from the left edge (similar to the image)
        top: '50%', // Vertically center the text
        transform: 'translateY(-50%)', // Adjust to perfectly center vertically
        maxWidth: '60%', // Allocate 40% of the width for the text section
        padding: 10, // Add padding for better text readability
        borderRadius: 5, // Optional: Add slight rounding to the background
    },
    productName: {
        fontSize: 24, // Larger font for the product name
        fontWeight: 'bold',
        color: '#000000', // Black color for the product name
        marginBottom: 5,
    },
    prductName: {
        flexDirection: 'column',
    },
    productDescription: {
        fontSize: 14, // Smaller font for the description
        color: '#333333', // Dark gray for the description
        marginBottom: 10,
    },
    productPrice: {
        fontSize: 16, // Medium font for the price
        fontWeight: 'bold',
        color: '#000000', // Black for the price
    },
    productInfoLinebreak: {
        marginVertical: 10, // Space between description and price
        height: "2px",
        width: "70%",
        backgroundColor: "#000000",
    },





    storeBannerSection: {
        position: 'relative', // Ensure the section can contain absolute children
        width: '100%',
        height: '100%',
    },
    storeBannerImageSection: {
        width: '100%', // Image takes full width of the page
        height: '100%', // Image takes full height of the page
    },
    storeBannerImage: {
        width: '100%', // Ensure the image fills the section
        height: '100%', // Ensure the image fills the section
        objectFit: 'cover', // Cover the area while maintaining aspect ratio (crops if needed)
    },
    storeContentSection: {
        position: 'absolute', // Overlay the text on top of the image
        bottom: 20, // Position 20 units from the bottom edge (similar to the image)
        left: 0,
        right: 0,
        width: '100%', // Take full width to center content
        paddingVertical: 15,
        paddingHorizontal: 20,
        textAlign: 'center', // Center the text like in the image
    },
    storeFirstContentSection: {
        marginBottom: 10, // Space between the two content sections
    },
    storeSecondContentSection: {
        marginBottom: 5,
    },
    storeText: {
        fontSize: 12, // Smaller font size to match the image's text
        color: '#000000', // Black text for contrast against the white background
        lineHeight: 1.5, // Add line spacing for readability
    },
    boldText: {
        fontWeight: 'bold', // Bold text for emphasis (store name, manager name, phone)
        fontSize: 12,
        color: '#000000',
    },







    // brandtext: {
    //     color: "#3d2d17",
    //     fontWeight: 500,
    //     fontSize: "20px",
    //     height: "30px",
    // },

    // Topbarsection: {
    //     margin: 10,
    //     padding: 10,
    //     justifyContent: "flex-end",
    //     flexDirection: "row",
    //     height: 40,
    //     position: "absolute",
    //     top: 5,
    //     alignItems: 'flex-end',
    //     backgroundColor: 'white',
    //     zIndex: 999
    // },
    // logo: {
    //     height: 30,
    //     alignItems: 'flex-end',
    // },


    // section: {
    //     display: "flex",
    //     padding: 10,
    //     flexGrow: 1,
    //     flexDirection: "row",
    //     justifyContent: "space-between",
    //     alignItems: "top",
    //     height: "20px",
    // },

    // productImage: {
    //     height: "300",
    // },
    // prductName: {
    //     color: "#222",
    //     fontWeight: 700,
    //     fontSize: "17px",
    //     margin: 4,
    //     paddingLeft: "10px",
    // },
    // button: {
    //     display: "flex",
    //     flexDirection: "row",
    //     justifyContent: "center",
    //     alignItems: "top",
    // },
    // price: {
    //     width: "50%",
    //     height: 30,
    //     backgroundColor: "#ecebeb",
    //     textAlign: "center",
    //     color: "#000",
    //     paddingTopTop: 2,
    //     textDecorationStyle: "none",
    // },
    // link: {
    //     width: "50%",
    //     height: 30,
    //     backgroundColor: "#a2703b",
    //     textAlign: "center",
    //     color: "#fff",
    // },
    // footer: {
    //     position: "absolute",
    //     bottom: 20,
    //     left: 0,
    //     right: 0,
    //     textAlign: "center",
    //     fontSize: 10,
    // },
    // Description: {
    //     marginLeft: 40,
    //     marginRight: 40,
    //     position: "relative",
    //     marginTop: "25%",
    //     flexDirection: "row",
    //     justifyContent: "center",
    //     alignItems: "center",
    // },
    // mybox: {
    //     bottom: 0,
    //     position: "absolute",
    //     left: 0,
    //     right: 0,
    //     textAlign: "center",
    //     fontSize: 9,
    //     color: "gray",
    //     borderBottom: "1px solid black"
    // },


    // pageImageStyle: {
    //     flexDirection: 'column',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     width: '100%',
    //     height: '100%',
    // },

    // firstFooter: {
    //     flexDirection: 'column',
    //     alignItems: 'flex-start',
    //     justifyContent: 'center',
    //     backgroundColor: 'white',
    //     width: '100%',
    //     height: '100%',
    //     display: "flex",
    //     textAlign: 'left',
    //     position: 'absolute',
    //     bottom: 450,
    //     left: 10,
    // },
    // product: {
    //     fontWeight: 'bold',
    //     fontSize: "30px",
    //     marginLeft: "0px",
    //     paddingLeft: "0px",
    //     letterSpacing: "1px"
    // },
    // productDes: {
    //     fontWeight: 'bold',
    //     fontSize: "10px",
    // },
    // productPrice: {
    //     fontWeight: 'bold',
    //     fontSize: "15px",
    // },
    // linebreak: {
    //     top: 60,
    //     left: 12,
    //     right: 0,
    //     borderBottom: "1px solid black",
    //     borderColor: 'black',
    //     width: '20%',
    // },
    // prductName: {
    //     color: "#000",
    //     fontSize: "9px",
    //     fontWeight: "light"
    // },

    // mybox: {
    //     position: "absolute",
    //     bottom: 40,
    //     left: 0,
    //     right: 0,
    //     textAlign: "center",
    //     fontSize: 9,
    //     borderBottom: "1px solid black",
    // },
    // footer: {
    //     display: "flex",
    //     flexDirection: "row",
    //     justifyContent: "space-between",
    //     alignItems: "top",
    //     position: "absolute",
    //     left: 0,
    //     right: 0,
    //     fontSize: 9,
    // },
    // firstFooter: {
    //     flexDirection: 'column',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     backgroundColor: 'white',
    //     width: '100%',
    //     height: '100%',
    //     display: "flex",
    //     textAlign: 'center',
    //     position: "absolute",
    //     bottom: 200,
    // },
    // boldText: {
    //     fontWeight: 'bold',
    //     fontSize: "10px",
    //     color: "#000"
    // },
    // secondFooter: {
    //     flexDirection: 'column',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     backgroundColor: 'white',
    //     width: '100%',
    //     height: '100%',
    //     display: "flex",
    //     textAlign: 'center',
    //     position: "absolute",
    //     bottom: 120,
    // },
});

const Blackberry = ({ jsonData, vendor }) => {
    const [Data, setData] = useState();

    useEffect(() => {
        setData(jsonData);
    }, [jsonData]);

    const [products, setProducts] = useState([]);

    console.log("Blackberry data:", Data)


    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.headerBannerSection}>
                    <Image src="/image/lookbookBanner.jpg" style={styles.headerBannerSectionImage} />
                </View>
            </Page>
            <Page size="A4" style={styles.page}>
                <View style={styles.headerBannerSection}>
                    <Image src="/image/topSecBanner.jpg" style={styles.headerBannerSectionImage} />
                </View>
            </Page>
            {Data === undefined ? (
                <Text>Data Not Available</Text>
            ) : (
                Data?.Product.map((item) => {
                    return (
                        <Page size="A4" style={styles.page}>
                            <View style={styles.productSection}>

                                <View style={styles.productImageSection}>
                                    <Image
                                        style={styles.productImage}
                                        src={
                                            item?.image && item?.image !== "N/A"
                                                ? item?.image
                                                : item?.productImage
                                        }
                                    />
                                </View>
                                <View style={styles.productInfoSection}>
                                    <Text style={styles.productName}>{item?.title}</Text>
                                    <Text style={styles.productDescription}>{item?.description ? item?.description : "Versatile, timeless, and stylish – our clothing enhances any look with premium fabrics and classic fits, perfect for every occasion."}</Text>
                                    <Text style={styles.productInfoLinebreak}></Text>
                                    <Text style={styles.productPrice}>Rs. {item?.price} /-</Text>
                                </View>
                            </View>
                        </Page>

                    )
                })
            )}
            {/* Footer Section */}
            {/* <Page size="A4" style={styles.page}>
                <View style={styles.footerBannersection}>
                    <View style={styles.footerBannerImageSection}>
                        <Image
                            style={styles.footerBannerImage}
                            src="/image/footerBanner.jpg"
                        />
                    </View>
                    <View style={styles.footerContentSection}>
                        <View style={styles.footerFirstContentSection}>
                            <Text style={styles.prductName}>Explore your nearest Blackberrys store at <Text style={styles.boldText}> {Data?.store?.storename} </Text>
                                {'\n'}
                                {'\n'}
                                for a first-hand look at our newest arrivals. Find your perfect fit with me,
                                {'\n'}
                                {'\n'}
                                <Text style={styles.boldText}> {Data?.store?.managername}, your Fit Expert.</Text>
                                {'\n'}
                            </Text>
                        </View>
                        <View style={styles.footerSecondContentSection}>
                            <Text style={styles.prductName}>– We're here to assist you in making your shopping experience extraordinary!
                                {'\n'}
                                {'\n'}
                                Get in touch with me at<Text style={styles.boldText}> - +91 {Data?.store?.storePhone}</Text>
                            </Text>
                        </View>
                    </View>
                </View>
            </Page> */}
            <Page size="A4" style={styles.page}>
                <View style={styles.storeBannerSection}>
                    {/* Store Image Section (Full Width and Height) */}
                    <View style={styles.storeBannerImageSection}>
                        <Image
                            style={styles.storeBannerImage}
                            src="/image/footerBanner.jpg" // Replace with your image path
                        />
                    </View>

                    {/* Store Content Section (Overlay with Absolute Positioning) */}
                    <View style={styles.storeContentSection}>
                        <View style={styles.storeFirstContentSection}>
                            <Text style={styles.storeText}>
                                Explore your nearest Blackberrys store at{' '}
                                <Text style={styles.boldText}>{Data?.Store?.storename}</Text>
                                {'\n'}
                                {'\n'}
                                for a first-hand look at our newest arrivals. Find your perfect fit with me,
                                {'\n'}
                                {'\n'}
                                <Text style={styles.boldText}>{Data?.Store?.managername}, your Fit Expert.</Text>
                            </Text>
                        </View>
                        <View style={styles.storeSecondContentSection}>
                            <Text style={styles.storeText}>
                                – We're here to assist you in making your shopping experience extraordinary!
                                {'\n'}
                                {'\n'}
                                Get in touch with me at{' '}
                                <Text style={styles.boldText}>+91 {Data?.Store?.storePhone}</Text>
                            </Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default Blackberry;
